import { render } from "./Settings.vue?vue&type=template&id=4a6d9954"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"
script.render = render

export default script